import { render, staticRenderFns } from "./14.vue?vue&type=template&id=238eb3c2&scoped=true&"
import script from "./14.vue?vue&type=script&lang=js&"
export * from "./14.vue?vue&type=script&lang=js&"
import style0 from "./14.vue?vue&type=style&index=0&id=238eb3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238eb3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238eb3c2')) {
      api.createRecord('238eb3c2', component.options)
    } else {
      api.reload('238eb3c2', component.options)
    }
    module.hot.accept("./14.vue?vue&type=template&id=238eb3c2&scoped=true&", function () {
      api.rerender('238eb3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/14.vue"
export default component.exports